:host {
  --aha-tab-list--border-bottom: 1px solid var(--aha-gray-400);

  display: flex;
  align-items: center;
  border-bottom: var(--aha-tab-list--border-bottom);
  font-size: 14px;
}

:host([data-focus-visible-added]:focus-within) {
  outline: 2px solid var(--aha-blue-500);
  outline-offset: 1px;
  border-bottom-color: transparent;
}

:host .tab-list-container {
  display: flex;
  align-items: center;
}

div {
  flex-shrink: 0;
}
